export const environment = {
  production: true,
  platform: 'next',
  baseHref:  '',
  apiUrl: 'http://ihdemo02.hopto.org:8080/api/',
  auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJodHRwczovL2ludGVybGFjZWhlYWx0aC5jb20iLCJuYW1lIjoiRXhwZXJpZW5jZSBCdWlsZGVyIiwiYXBwVXJsIjoiaHR0cDovL2loZGVtbzAyLmhvcHRvLm9yZzo4MyIsImlhdCI6MTU4NDk3Njk5NX0.t4P5qaRTVVLXjMgobh5GS4A99jw2-MukcaiP7JJdW9E",
  nextViewerUrl: "http://ihdemo02.hopto.org:81/",
};
